import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ActionButton from '../../elements/action-button/ActionButton';

const ModalButtons = ({
  cancelProps,
  actionProps,
  actionText,
  cancelText,
  danger,
  onCancel,
  onAction,
}) => {
  const { t } = useTranslation();

  return (
    <DialogActions>
      <Button variant="text" onClick={onCancel} {...cancelProps}>
        {cancelText || t('cancel', { ns: 'buttons' })}
      </Button>
      <ActionButton
        clickAction={onAction}
        color={danger && 'error'}
        data-testid="modal-confirm"
        {...actionProps}
      >
        {actionText}
      </ActionButton>
    </DialogActions>
  );
};

ModalButtons.propTypes = {
  cancelProps: PropTypes.object,
  actionProps: PropTypes.object,
  actionText: PropTypes.string.isRequired,
  cancelText: PropTypes.string,
  danger: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onAction: PropTypes.func,
};

export default ModalButtons;
